import { DataType } from '@/screens/Order/Pages/EditOrder/components/ProductRequirementForm/measurement.column'
import HeaderComponent from '@/screens/SystemConfigure/Components/HeaderComponent/HeaderComponent'
import PopUpMenu from '@/screens/SystemConfigure/Components/PopUpMenu/PopUpMenu'
import ToolbarComponent from '@/screens/SystemConfigure/Components/ToolbarComponent/ToolbarComponent'
import { Space } from 'antd'
import Table, { ColumnsType } from 'antd/lib/table'
import { useEffect, useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import { deleteDefectItem, getDefectItem } from '../../DataManagement.transform'
import './DefectItem.style.less'
import AddDefectItemModal from './AddDefectItem/AddDefectItemModal'
import { useParams } from 'react-router-dom'
import { isEmptyValue } from '@/utils/common'
import { lowerCase } from 'lodash'

function DefectItem() {
  const [modalDefectItem, setModalDefectItem] = useState(false)

  const [value, setvalue] = useState([])

  const [selectedDefectItem, setselectedDefectItem] = useState(null)

  const onEdit = (item) => {
    setselectedDefectItem(item)
    setModalDefectItem(true)
  }

  const onAdd = () => {
    setselectedDefectItem(null)
    setModalDefectItem(true)
  }

  const deleteMutation = useMutation(async (item: any) => {
    await deleteDefectItem(item)
  })

  const onDelete = async (item: any) => {
    await deleteMutation.mutateAsync({ ...item, defect_group_id: param?.id })
    await refetch()
  }

  const param = useParams()

  const columns: ColumnsType<DataType> = [
    {
      title: 'id',
      dataIndex: 'id',
      key: 'id',
      className: 'hide-column',
    },
    {
      title: 'DEFECT NAME',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: 'HEAD RANK',
      dataIndex: 'head_rank',
      key: 'head_rank',
      align: 'left',
    },
    {
      title: 'CODE',
      dataIndex: 'code',
      key: 'code',
      align: 'left',
    },
    {
      title: 'CLASSIFICATION',
      dataIndex: 'classification',
      key: 'classification',
      align: 'left',
      render: (value: string) => value ? value.toUpperCase() : '-',
    },
    {
      title: 'ACTION',
      key: 'action',
      render: (_, record: any) => (
        <Space size="middle">
          <PopUpMenu
            onEdit={() => {
              onEdit(record)
            }}
            onDelete={() => onDelete(record)}
          />
        </Space>
      ),
      width: '5%',
    },
  ]

  const {
    data: dataList,
    isLoading,
    refetch,
  } = useQuery(['defect-item', param?.id], async () => {
    return await getDefectItem(param?.id)
  })

  useEffect(() => {
    if (!isLoading) {
      setvalue(dataList.data.defect_lists)
    }
  }, [dataList, isLoading])

  const onSearch = (search) => {
    if (isEmptyValue(search)) {
      setvalue(dataList.data.defect_lists)
    } else {
      const tmp = [...dataList.data.defect_lists]
      const result = tmp.filter(
        (obj) =>
          lowerCase(obj.name)?.includes(lowerCase(search)) ||
          lowerCase(obj.code)?.includes(lowerCase(search))
      )
      setvalue(result)
    }
  }

  return (
    <>
      <HeaderComponent isBack title={'Edit Defect List'} />
      <ToolbarComponent
        subTitle={dataList?.data?.name}
        onSearch={onSearch}
        onAdd={onAdd}
        buttonText="Add New"
      />
      <Table loading={isLoading} columns={columns} dataSource={value} />
      {modalDefectItem && (
        <AddDefectItemModal
          visible={modalDefectItem}
          onClose={() => setModalDefectItem(false)}
          data={selectedDefectItem}
        />
      )}
    </>
  )
}

export default DefectItem
